import { VcardData } from "@/types/qr";
import { isClient } from "./browser";

const imageToBase64 = (url) =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );

export const generateVCard = async (vcardData: VcardData) => {
  const {
    fullName,
    mobilePhone,
    landlinePhone,
    fax,
    email,
    address,
    website,
    companyName,
    profession,
    logoUrl,
  } = vcardData;
  let imageEncoded;

  logoUrl &&
    (await imageToBase64(logoUrl).then((dataUrl: string) => {
      imageEncoded = dataUrl.split(",")[1];
    }));

  const makeVCardVersion = () => `VERSION:3.0`;
  const makeVCardInfo = (fullName) => `FN:${fullName}`;
  const makeVCardName = (fullName) => `N:;${fullName};;`;
  const makeVCardOrg = (companyName) => `ORG:${companyName || ""}`;
  const makeVCardTitle = (profession) => `TITLE:${profession || ""}`;
  const makeVCardPhoto = () => `PHOTO;ENCODING=b:${imageEncoded || ""}`;
  const makeVCardMobilePhone = (mobilePhone) => `TEL;TYPE=CELL:${mobilePhone || ""}`;
  const makeVCardLandlinePhone = (landlinePhone) => `TEL;TYPE=WORK:${landlinePhone || ""}`;
  const makeVCardFaxPhone = (fax) => `TEL;TYPE=WORK,FAX:${fax || ""}`;
  const makeVCardAdr = (address) => `ADR;TYPE=WORK:;;${address || ""}`;
  const makeVCardEmail = (email) => `EMAIL:${email || ""}`;
  const makeVCardWebsite = (website) => `URL:${website || ""}`;
  const makeVCardTimeStamp = () => `REV:${new Date().toISOString()}`;

  // No dejar espacios entre saltos de linea
  let vcard = `BEGIN:VCARD
${makeVCardVersion()}
${makeVCardPhoto()}
${makeVCardInfo(fullName)}
${makeVCardName(fullName)}
${makeVCardOrg(companyName)}
${makeVCardTitle(profession)}
${makeVCardMobilePhone(mobilePhone)}
${makeVCardLandlinePhone(landlinePhone)}
${makeVCardFaxPhone(fax)}
${makeVCardAdr(address)}
${makeVCardEmail(email)}
${makeVCardWebsite(website)}
${makeVCardTimeStamp()}
END:VCARD`;

  var blob = new Blob([vcard.trim()], { type: "text/x-vcard" });
  var downloadUrl = URL.createObjectURL(blob);
  var a = document.createElement("a");
  a.href = downloadUrl;
  a.download = "vcard" + ".vcf";
  document.body.appendChild(a);
  a.click();
};

export const downloadTypeOfData = (data: string | ArrayBuffer, type: string, fileName: string) => {
  try {
    const blob = new Blob([data], {
      type,
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;

    link.click();

    window.URL.revokeObjectURL(link.href);
  } catch (err) {
    console.error("Error downloading the asset:", err);
  }
};

export const downloadXLSX = async (data: string, label: string) => {
  const fileName = `${label}.xlsx`;
  const headerType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  const response = await fetch(`data:application/octet-stream;base64,${data}`);
  const binaryData = await response.arrayBuffer();

  downloadTypeOfData(binaryData, headerType, fileName);
};

export const downloadCSV = async (data: string, label: string) => {
  const fileName = `${label}.csv`;
  const headerType = "text/csv";

  downloadTypeOfData(data, headerType, fileName);
};

export const downloadPDF = async (pdf: Uint8Array, fileName: string) => {
  if (isClient()) {
    downloadTypeOfData(pdf.buffer, "application/pdf", fileName);
  }
};
